import React from 'react';
import HdModal from '../../../../modal/components/modal/HdModal';
import { CollapsibleQueryResult, QueryResultBaseProps } from './CollapsibleQueryResult';

export interface QueryResultDialogProps extends QueryResultBaseProps {
  toggleExpandedView: Function;
  open?: boolean;
}

export function QueryResultDialog({ open, ...props }: QueryResultDialogProps) {
  return (
    <HdModal
      open={open}
      onClose={() => props.toggleExpandedView()}
      contentClassName='surface-on-surface'
      styling={{
        width: '1170px',
        maxWidth: '100%',
        height: '610px'
      }}
    >
      <CollapsibleQueryResult
        {...props}
        isExpandedView={true}
        useVirtualScrolling={true}
      />
    </HdModal>
  );
}
